export const RELVAL_SNAPSHOT_FIELDS = [
  "IDENTIFIER",
  "ASSET_CLASS",
  "SUB_CLASS",
  "SHORT_NAME",
  "SOURCE",
  "LAST_UPDATED_DATE",
  "RATING",
  "WAL",
  "CURRENT_SPREAD",
  "ASSET_LEVERAGE",
  "FRICTION_COST_TO_TARGET",
  "REMAINING_C1_PERMITTED",
  "BASE_RATE",
  "IMPLIED_YIELD",
  "RBC",
  "SPREAD_RBC_CAPITAL",
  "SP_CAPITAL",
  "SPREAD_SP_CAPITAL",
  "FIXED_FLOATING",
  "COLLATERAL_WAL_STRUCT",
  "SPREAD_DUR_RANGE",
  "BOND_STRUCT_NOTES",
  "WOW_SPREAD_CHANGE",
  "SPREAD_HISTORY_MIN_DATE",
  "RANGE_2025",
  "RANGE_3Y",
  "FIELD",
  "VALUE_UNIT",
  "ROW_ORDER",
];

const NATIVE_VALUE_UNITS = {
  "Freddie Mac Commitment": "PERCENT",
  "CC MBS": "PERCENT",
  "CC MBS OAZ": "BPS",
  "CC MBS OAS": "BPS",
  "MOVE Index": "INDEX_POINTS",
};

export const getRelValValueUnit = (row, { assetMenuStorage = false } = {}) => {
  if (row?.FIELD === "INDEX_OAS_TSY") {
    return assetMenuStorage ? "BPS" : "PERCENT";
  }
  return NATIVE_VALUE_UNITS[row?.SHORT_NAME] || "BPS";
};

export const RELVAL_NUMERIC_FIELDS = new Set([
  "CURRENT_SPREAD",
  "ASSET_LEVERAGE",
  "FRICTION_COST_TO_TARGET",
  "REMAINING_C1_PERMITTED",
  "IMPLIED_YIELD",
  "RBC",
  "SPREAD_RBC_CAPITAL",
  "SP_CAPITAL",
  "SPREAD_SP_CAPITAL",
  "WOW_SPREAD_CHANGE",
]);

const normalizeNumeric = (value, field, row) => {
  if (value == null || value === "") return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    throw new Error(
      `Invalid ${field} for ${row.SHORT_NAME || row.IDENTIFIER || "snapshot row"}`,
    );
  }
  return numeric;
};

const snapshotNumeric = (row, field) => {
  const numeric = normalizeNumeric(row[field], field, row);
  if (
    numeric != null &&
    field === "CURRENT_SPREAD" &&
    row.FIELD === "INDEX_OAS_TSY"
  ) {
    return numeric * 100;
  }
  return numeric;
};

export const buildRelValSnapshotRows = (rows) =>
  rows.map((row, index) => {
    const snapshot = RELVAL_SNAPSHOT_FIELDS.reduce(
      (snapshotRow, field) => ({
        ...snapshotRow,
        [field]: RELVAL_NUMERIC_FIELDS.has(field)
          ? snapshotNumeric(row, field)
          : field === "ROW_ORDER"
            ? (row[field] ?? index)
            : (row[field] ?? null),
      }),
      {},
    );
    snapshot.VALUE_UNIT = getRelValValueUnit(row, {
      assetMenuStorage: true,
    });
    return snapshot;
  });

export const buildRelValOverrideRows = (rows) =>
  rows.map((row) => {
    const spread = normalizeNumeric(row.CURRENT_SPREAD, "CURRENT_SPREAD", row);
    if (spread == null) {
      throw new Error(
        `Invalid CURRENT_SPREAD for ${row.SHORT_NAME || row.IDENTIFIER || "override row"}`,
      );
    }
    return {
      IDENTIFIER: row.IDENTIFIER ?? null,
      SHORT_NAME: row.SHORT_NAME ?? null,
      CURRENT_SPREAD: spread,
      FIELD: row.FIELD ?? null,
      VALUE_UNIT: getRelValValueUnit(row),
    };
  });
